// @flow
import pickExcept from 'mz-utils/pickExcept'
import normalize from '../../utils/normalize'

/**
 * FIXME: get rid of that transformation function
 */
export const filterReserveQuery = (query: Object): Object => {
  const transformers = {
    trip_id: (val) => ({ result_id: val }),
    pax_first_name: (val) => ({ first_name: val }),
    pax_last_name: (val) => ({ last_name: val }),
    session_id: (val) => ({ search_id: val }),
    coupon_code: (val) => val && { coupon_code: val },
  }

  let normData = normalize(query, transformers)

  if (query.ondemand) {
    normData.ride_id = normData.result_id
    normData.customer_notes = normData.customer_special_instructions
    normData.passenger_information = {
      first_name: normData.first_name,
      last_name: normData.last_name,
      phone_country_code: normData.country_code_name.toUpperCase(),
      phone_national_number: normData.phone_number,
      email: normData.email,
    }

    normData = pickExcept(normData, {
      first_name: true,
      last_name: true,
      email: true,
      phone_number: true,
      country_code_name: true,
    })
  }

  return normData
}

export default filterReserveQuery
